import {
  type DataTestId,
  type StylingProps,
  type WithChildren,
} from '@dynatrace/strato-components/core';

import { InternalBaseItem as BaseItem } from '../form-field-messages/FormFieldMessageBaseItem.js';

/**
 * @public
 */
export interface HintProps extends WithChildren, StylingProps, DataTestId {
  /**
   * Whether the connected input is currently disabled.
   * @defaultValue false
   */
  disabled?: boolean;
  /** Id to link the hint to its corresponding element. */
  id?: string;
}

/**
 * Renders a hint message if given, otherwise renders nothing.
 * @public
 */
export const Hint = (props: HintProps) => {
  const { children, ...remainingProps }: HintProps = props;

  return children ? (
    <BaseItem variant={'hint'} {...remainingProps}>
      {children}
    </BaseItem>
  ) : null;
};

Hint.displayName = 'Hint';
